import type { PickUnionLiterals } from '../../../../interfaces/PickUnionLiterals';
import type { States } from '../../machine/types';

export const isValidAuthenticationFlow = (
  flow: string,
): flow is PickUnionLiterals<States, 'login' | 'signUp'> => flow === 'login' || flow === 'signUp';
